import { render, staticRenderFns } from "./AttritionAnalysisPageConfigEdit.vue?vue&type=template&id=5850c952&"
import script from "./AttritionAnalysisPageConfigEdit.vue?vue&type=script&lang=ts&"
export * from "./AttritionAnalysisPageConfigEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports